import { Observable } from 'rxjs';

export const ACCOUNTING_REPOSITORY = 'AccountingRepository';

export interface AccountingRepository {
  downloadBalanceInterface(data: any): Observable<any>;

  downloadMasterTransfers(data: any): Observable<any>;

  downloadMovementInterface(data: any): Observable<any>;

  downloadTransactionsEvents(data: any): Observable<any>;

  downloadTransactionsLogEvents(data: any): Observable<any>;

  downloadTotalsCosts(data: any): Observable<any>;

  downloadTotalsCostsSentinel(data: any): Observable<any>;

  getTypeEvent(): Observable<any>;

}
